import React from "react";
import { Accordion, AccordionTab } from 'primereact/accordion';
import ProWaitlistClientActionMenu from "./ProWaitlistClientActionMenu";
import ProWaitlistClientDetails from "./ProWaitlistClientDetails";
import _ from "lodash";

const ProWaitlistClient = ({data, performAction})=>{   
    let baseUrl = _.gt(window.location.ancestorOrigins.length, 0)?_.first(window.location.ancestorOrigins) : "https://example.com"
   
    const url = _.get(data, "client")?`${baseUrl}/clients/edit.jsp?sid=${localStorage.getItem('sid')}&s_id=${data.client.id}&mode=change`:""

    const headerTemplate = ()=>{
        return (
            <div className="p-grid p-waitlist-client-basic">
                <div className="p-sm-1 p-waitlist-client-light">{data.waitlistPriority}</div>
                {_.get(data, "client") && <div className="p-sm-fixed p-waitlist-client-standard">{data.client.gender}</div> }
                {_.get(data, "client") && <div className="p-sm-2 p-waitlist-client-standard" style={{textAlign:'center'}}>{data.client.age}</div> }
                {_.get(data.client, "isPregnant") && <div className="p-sm-2 p-waitlist-client-light">Pregnant</div> }
            </div>
        )
    }

    return (
        <>
        <div className="p-grid p-waitlist-client-header p-justify-between">
        {_.get(data.client, "id") && <div className="p-waitlist-client p-col-4">
        <i className="fal fa-user p-waitlist-client-icon" >
                    </i> <a className="p-col-fixed"  rel="noreferrer" href={url} target="_blank"><span style={{ fontWeight: 'bold', color:'blue', textDecoration:'underline' }}>{`${data.client.lastName}, ${data.client.firstName}`}</span></a><span>{`  (${data.client.number})`}</span></div>}
        {!_.get(data.client, "id") && <div className="p-waitlist-client p-col-4">
            <i className="fal fa-user p-waitlist-client-icon" >
                    </i> <span style={{marginLeft:"10px"}}>{`${data.pendingClientName}`}</span></div>}
               <div className="p-waitlist-client-action p-col-fixed">
                <ProWaitlistClientActionMenu data ={data} performAction={performAction}/>
        </div>             
        </div>
        <Accordion  multiple style={{ overflow:'auto'}}>
        <AccordionTab className="p-waitlist-client-accordion-tab" headerTemplate={headerTemplate} >
           <ProWaitlistClientDetails data={data}/>
        </AccordionTab>         
    </Accordion>  
    </>      
    )

}

export default ProWaitlistClient;